import * as Selection from './selectionReducer';
import * as Validation from './validationReducer';

const reducers = {
  ...Selection,
  ...Validation,
};

export default reducers;
